import React from 'react';
import ReactDOM from 'react-dom';

const ReactHint = require('react-hint')(React);

export default () => {
  ReactDOM.render(
    <ReactHint events={{ events: true, focus: true, hover: true }} />,
    document.querySelector('.js-tooltip'),
  );
};



// WEBPACK FOOTER //
// ./app/Assets/js/features/components/enableTooltips.js